<template>
  <div>
    <MasterHeader
      v-bind:classHeader="classHeader"
      v-bind:classGrid="classGrid"
      v-bind:routeTo="routeTo"
      v-bind:showToastError="showToastError"
      v-bind:showToastMessage="showToastMessage"
    />
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration padd">
          <hr class="blue" />
          <h4>{{ $t('profile.residence_address') }}</h4>
          <form class="custom-form" 
            v-on:submit.prevent="onSubmit()"
            >
            <div class="form-group" v-bind:class="{ 'not-empty': !isAddressEmpty }">
              <input type="text" class="form-control" name="street" id="street" v-model="address" @keydown="getAddresses()" @blur="formUtilsCheckAddress()" />
              <a class="close-address-list" v-if="addresses.length > 0 && showAddressList" @click="closeAddressCodelist()"></a>
              <label for="street" class="animated-label">{{ $t('profile.street_and_house_number') }}</label>
              <span class="line"></span>
              <ul class="address-codelist" v-if="addresses.length > 0 && showAddressList">
                <li class="address-codelist__item" v-for="address in addresses">
                  <a class="address-codelist__action" v-on:click="setAddress(address)">{{ address.address }} {{ address.post_code }} {{ address.town }}</a>
                </li>
              </ul>
            </div>

            <div class="form-group" v-bind:class="{ 'not-empty': !isPostalCodeEmpty }">
              <input type="number" 
                    class="form-control" 
                    name="post" 
                    id="post" 
                    v-model="postalCode" 
                    @blur="formUtilsCheckPostalCode()" 
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    maxlength="4"/>
              <label for="post" class="animated-label">{{ $t('profile.postal_code') }}</label>
              <span class="line"></span>
            </div>

            <div class="form-group" v-bind:class="{ 'not-empty': !isCityEmpty }">
              <input type="text" class="form-control" name="city" id="city" v-model="city" @blur="formUtilsCheckCity()" v-on:keypress="cityCharacter" v-on:keydown="cityValid" />
              <label for="city" class="animated-label">{{ $t('profile.city') }}</label>
              <span class="line"></span>
            </div>

            <hr class="blue topMargin" />
            <h4>{{ $t('profile.your_mobile_number') }}</h4>
            <div class="flex phoneNumber">
              <div class="form-group zipNumber">
                <label class="animated-label">+{{ cityCode }}</label>
              </div>

              <div class="form-group">
                <input
                  type="number"
                  class="form-control"
                  name="Number"
                  id="Number"
                  v-model="phone"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="8"
                />

                <span class="line"></span>
              </div>
            </div>

            <div class="next flex">
              <a class="txt" href v-on:click.prevent="formUtilsCancel()">{{ $t('profile.cancel') }}</a>

              <a
                class="join smallFont smallWidth hoverEffect"
                ref="joinButton1"
                v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:click.prevent="onSubmit()"
                href="javascript:void(0);"
              
              >
                <label>{{ $t('profile.save') }}</label>
                <span class="effect" ref="effectButton1" v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"></span>
              </a>
            </div>

          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MasterHeader from '../partials/MasterHeader';
import { debounce } from '../../helpers';
import { 
  formUtilsCheckAddress, 
  formUtilsCheckPostalCode, 
  formUtilsMouseHoverEffect, 
  formUtilsCheckCity, 
  formUtilsValidateSloveniaPhoneNumber,
  formUtilsCancel
} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      classHeader: 'registration',
      classGrid: 'wp1200',
      routeTo: 'dashboard',
      showToastError: false,
      showToastMessage: '',
      cityCode: '386',
      isAddressEmpty: true,
      address: '',
      isPostalCodeEmpty: true,
      postalCode: '',
      isCityEmpty: true,
      addresses: [],
      city: '',
      phone: '',
      isPhoneValid: false,
      isPhoneValidMessage: this.$t('slovenia_phone_valid'),
      topX: 1,
      leftX: 1,
      recaptchaToken: '',
      recaptchaSiteKey: window.VUE_APP_RECAPTCHA_KEY,
      showAddressList:false
    };
  },
  components: {
    MasterHeader,
  },
  setup() {},
  computed: {
    user() {
      return this.$store.getters['user/user'];
    },
  },
  mounted() {
    this.autoFillInputs();
  },
  methods: {
    formUtilsMouseHoverEffect,
    formUtilsCheckAddress,
    formUtilsCheckPostalCode,
    formUtilsCheckCity,
    formUtilsValidateSloveniaPhoneNumber,
    formUtilsCancel,

    async onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */
      if (!this.address || !this.postalCode || !this.city || !this.phone) {
        this.showToastError = true;
        this.showToastMessage = this.$t('error.data_missing');
        return false;
      }
      if (this.isAddressEmpty === false) {
        this.user.address = this.address;
      }

      if (this.isPostalCodeEmpty === false) {
        this.user.postal_code = this.postalCode;
      }

      this.user.phoneNumber = '386' + this.phone;

      if (this.isCityEmpty === false) {
        this.user.city = this.city;
      }

      if (!this.formUtilsValidateSloveniaPhoneNumber()) {
        this.showToastError = true;
        this.showToastMessage = this.$t('error.invalid_phone_number');
        return false;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },

    sendForm(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      this.$http
        .put('api/v1/userinfo', this.user)
        .then((response) => {
          this.$store.commit('user/user', response.body);
          this.$store.dispatch('user/userinfo');
          this.$router.back();
          return;
        })
        .catch(() => {
          this.showToastError = true;
          this.showToastMessage = this.$t('error.invalid_update');
        });
    },

    getAddresses: debounce(function() {
      if(this.address.length > 0){
        this.showAddressList = true;
      } else {
        this.showAddressList = false;
      }
      this.$http.get(`https://egp-api-klub.episcenter.si/api/v1/addresses?limit=6&search=${this.address.replace(/,/g, '')}`).then((response) => {
        this.addresses = response.body;
      });
    }, 300),

    cityCharacter: function(e) {
      var key = e.keyCode;
      if (key >= 48 && key <= 57) {
        e.preventDefault();
      }
    },
    autoFillInputs() {
      this.address = this.user.address;
      if (this.address !== null) {
        this.isAddressEmpty = false;
      }

      this.postalCode = this.user.postal_code;
      if (this.postalCode !== null) {
        this.isPostalCodeEmpty = false;
      }

      this.city = this.user.city;
      if (this.city !== null) {
        this.isCityEmpty = false;
      }

      this.phone =  (this.user.phoneNumber.includes('386')) ? this.user.phoneNumber.substring(3) : this.user.phoneNumber;
    },


    cityValid(event) {
      return /[a-z]/i.test(event.key);
    },
    setAddress(address) {
      this.address = address.address;
      this.postalCode = address.post_code;
      this.city = address.town;
      this.addresses = [];
    },
    closeAddressCodelist(){
      this.showAddressList = false;
    },
  },
};
</script>

<style>
.address-codelist {
  display: block;
  background: white;
  position: absolute;
  z-index: 99;
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid #d0d2d3;
  list-style: none;
  cursor:pointer;
}

.address-codelist .address-codelist__item {
  padding: 5px 0px;
}
.address-codelist .address-codelist__action {
  color: #0297a7;
  text-decoration: none;
  position: relative;
  cursor: pointer;
}

.address-codelist .address-codelist__action:after {
  content: '';
  display: block;
  width: 0;
  height: 3px;
  background: #0297a7;
  transition: width 0.3s;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -3px;
}

.address-codelist .address-codelist__action:hover:after {
  width: 100%;
}

.phoneNumber input::-webkit-outer-spin-button,
.phoneNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.close-address-list {
  position: absolute;
  right: 0px;
  top: 30px;
  width: 15px;
  height: 15px;
  z-index: 9;
  background:transparent;
  border:none;
  cursor:pointer;
}

.close-address-list:before, .close-address-list:after {
  position: absolute;
  left: 6px;
  content: ' ';
  height: 18px;
  width: 2px;
  background-color: #0297A7;
}
.close-address-list:before {
  transform:translate(-50%, -50%) rotate(45deg);
}
.close-address-list:after {
  transform:translate(-50%, -50%) rotate(-45deg);
}
</style>
